<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="100px">
        <div class="input-box" v-show="!out">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="idCard">
              <el-input v-model="form.idCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('ygdxbttjb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._n"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/以工代训补贴统计表--导入.xls" download="以工代训补贴统计表.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button  v-if="showBtn[5].isShow" type="primary" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo1"
          :key="index"
          :prop="item.key"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="以工代训补贴统计表"
      :visible.sync="centerDialogVisible"
      :modal="false"
      @close="close"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="name" label="姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="身份证号">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item label="现居地：">
                          <el-input style="width:193px;" v-model="editForm.address"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="就业单位：">
                          <el-input style="width:193px;" v-model="editForm.workOrganization"></el-input>
                        </el-form-item>
                        <el-form-item label="就业开始时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.startWorkTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="就业结束时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.endWorkTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="月均工资(元)：">
                          <el-input style="width:193px;" v-model="editForm.salary"></el-input>
                        </el-form-item>
                        <el-form-item label="就业地点：">
                          <el-input style="width:193px;" v-model="editForm.workPlace"></el-input>
                        </el-form-item>
                        <el-form-item label="所属行业产业：">
                          <el-select size="mini" v-model="editForm.workType" placeholder="请选择">
                            <el-option
                              v-for="item in $public.suoShuHangYeCY"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="其它产业说明：">
                          <el-input style="width:193px;" v-model="editForm.otherWorkDesc"></el-input>
                        </el-form-item>
                        <el-form-item label="签订劳动合同：">
                          <el-select size="mini" v-model="editForm.contract" placeholder="请选择">
                            <el-option
                              v-for="item in $public.options"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="缴纳社会保险：">
                          <el-select size="mini" v-model="editForm.socialInsurance" placeholder="请选择">
                            <el-option
                              v-for="item in $public.options"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="经帮扶实现就业：">
                          <el-select size="mini" v-model="editForm.fromHelpToWork" placeholder="请选择">
                            <el-option
                              v-for="item in $public.options"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="返乡创业带动：">
                          <el-select size="mini" v-model="editForm.fromSetupToWork" placeholder="请选择">
                            <el-option
                              v-for="item in $public.options"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="补贴金额(元)：">
                          <el-input style="width:193px;" v-model="editForm.allowanceFee"></el-input>
                        </el-form-item>
                        <el-form-item label="数据来源：">
                          <el-input style="width:193px;" v-model="editForm.dateSource"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/trainingWorkAllowance',
      form:{},
      type:'7',
      centerDialogVisible:false,
      tableData:[],
      tableData1:[],
      selectRow:[],
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key: 'name', value: '姓名'},
        {key: 'idCard', value: '身份证号'},
        {key: 'address', value: '现居地'},
        {key: 'phone', value: '联系电话'},
        {key: 'workOrganization', value: '就业单位'},
        {key: 'startWorkTime', value: '就业开始时间'},
        {key: 'endWorkTime', value: '就业结束时间'},
        {key: 'salary', value: '月均工资（元）'},
        {key: 'workPlace', value: '就业地点'},
        {key: 'workType', value: '所属行业产业'},
        {key: 'otherWorkDesc', value: '其它产业说明'},
        {key: 'contract', value: '签订劳动合同'},
        {key: 'socialInsurance', value: '缴纳社会保险'},
        {key: 'fromHelpToWork', value: '经帮扶实现就业'},
        {key: 'fromSetupToWork', value: '返乡创业带动'},
        {key: 'allowanceFee', value: '补贴金额(元)'},
        {key: 'dateSource', value: '数据来源'},
      ],
      baseInfo1:[
        {key: 'areaName', value: '行政区划名称'},
        {key: 'total', value: '总人数'},
        {key: 'trainingCount', value: '以工代训补贴人数'},
        {key: 'workshopCount', value: '就业扶贫车间以工代训补贴人数'},
        {key: 'allowanceCount', value: '补贴金额'},
      ],
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
      },
      isCreate:false,
      out:false,
    }
  },
  created() {
    this.isShowBtn("TrainingWorkAllowance")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.startWorkTime = new Date(newForm.startWorkTime).getTime()
      newForm.endWorkTime = new Date(newForm.endWorkTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>